export const CONST_PIE_SLICE = 32.7;
export const CONST_PIE_LABEL = 29.7;
